__turbopack_context__.v({
  "root": "Exbfbq_root",
  "stickyWrapper": "Exbfbq_stickyWrapper",
});
